import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import {SocketProvider} from './context';

ReactDOM.render(
  <SocketProvider>
  <Provider store={configureStore({})}>
    <BrowserRouter>
        <App />
    </BrowserRouter>
  </Provider>
  </SocketProvider>,
  document.getElementById("root") 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
